import { INews } from 'api/types/_news';
import { CONFIG_OPTION_TOAST_INFO } from 'common/toast';
import CopyWrapper from 'components/Common/CopyWrapper';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import DropdownStatus from 'components/Common/DropdownStatus';
import LabelWrapper from 'components/Common/LabelWrapper';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { COLORS_STATUS_NEWS, KEYWORD_TYPE, SECTION_KEYWORD, STATUS_NEWS_OPTIONS } from 'helpers/constans';
import { formatNumberWithCommas } from 'helpers/format';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import ModalImportGenerateBoostingNewsV2 from 'pages/News/BoostingNews/ModalImportGenerateBoostingNewsV2';
import BoxFooterNews from 'pages/News/Components/BoxFooterNews';
import BoxGeneratedNews from 'pages/News/Components/BoxGeneratedNews';
import ButtonLanguage from 'pages/News/Components/ButtonLanguage';
import HighlightText from 'pages/News/Components/HighlightText';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { getAINewsByNormal, getNewsWeatherWarningLogs as onGetNewsWeatherWarningLogs } from "../../../store/thunks";
import ModalPrompt from '../ModalPrompt';

export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'created_at';

registerLocale('en', en);
registerLocale('ko', ko);

const LogList = (activeTab?: any) => {
    let document_w: any = window.document;
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const modalRef = useRef<any>(null);
    const modalBodyInnerRef = useRef<any>(null);

    const modalSourceInnerRefs = useRef<any>([]);


    const STATUS_LOG_OPTIONS_LANG = [{ label: 'Initial', value: '1' }, { label: 'Failed', value: '2' }, { label: 'Completed', value: '3' }]?.map((item: any) => ({
        value: item?.value,
        label: t(item?.label),
    }));

    const STATUS_LOG_OPTIONS_COLOR = {
        '1': 'primary',
        '2': 'danger',
        '3': 'success',
    };

    const STATUS_NEWS_OPTIONS_LANG = STATUS_NEWS_OPTIONS?.map((item: any) => ({
        value: item?.value,
        label: t(item?.label),
    }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        keyword: withDefault(StringParam, ''),
        status: withDefault(StringParam, ''),
        start_date: withDefault(StringParam, moment().format('Y-MM-DD')),
        end_date: withDefault(StringParam, moment().format('Y-MM-DD')),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        type: withDefault(StringParam, '2'),
    });

    const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");
    const [statusSearch, setStatusSearch] = useState<typeof STATUS_LOG_OPTIONS_LANG[0] | null>(STATUS_LOG_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.status)) || null);
    const [dateSearch, setDateSearch] = useState<any[]>([query?.start_date ? moment(query?.start_date, 'Y-MM-DD').toDate() : null, query?.end_date ? moment(query?.end_date || '', 'Y-MM-DD').toDate() : null]);
    const [startDate, endDate] = dateSearch;

    const [newsDetail, setNewsDetail] = useState<INews | null>(null);

    const [listNews, setListNews] = useState<{ list: INews[], total: number }>({ list: [], total: 0 });
    const [isListNewsLoading, setIsListNewsLoading] = useState<boolean>(false);

    const [idLoading, setIdLoading] = useState<string | number | null>(null);

    const [isOpenModalNews, setIsOpenModalNews] = useState<boolean>(false);

    const [isOpenImportGenerateBoostingNewsV2, setIsOpenImportGenerateBoostingNewsV2] = useState<boolean>(false);

    const [isOpenModalConfigPrompt, setIsOpenModalConfigPrompt] = useState<boolean>(false);

    const [queryModal, setQueryModal]: any = useState({
        time_request: 0,
        page: 1,
        limit: 500,
        sort_by: 'id',
        order_by: 'DESC',
        news_ids: '',
        section: `${SECTION_KEYWORD.BOOSTING}`,
        type_page_no_param: '',
    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state.News;

    const NewsProperties = createSelector(
        selectLayoutState,
        (state) => ({
            newsWeatherWarningLogs: state.newsWeatherWarningLogs,
            isNewsWeatherWarningLogSuccess: state.isNewsWeatherWarningLogSuccess,
            isNewsWeatherWarningLogLoading: state.isNewsWeatherWarningLogLoading,
            error: state.error,
        })
    );

    // Inside your component
    const { newsWeatherWarningLogs, error, isNewsWeatherWarningLogLoading } = useSelector(NewsProperties);

    useEffect(() => {
        dispatch(onGetNewsWeatherWarningLogs(query));
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            keyword: keywordSearch || '',
            status: statusSearch?.value || '',
            type: '2',
            start_date: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
            end_date: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
            page: 1,
            time_request: + new Date()
        };
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            ...query,
            keyword: '',
            status: '',
            type: '2',
            start_date: moment().format('Y-MM-DD'),
            end_date: moment().format('Y-MM-DD'),
            order_by: 'DESC',
            sort_by: TYPE_SELECT_DEFAULT,
            time_request: + new Date(),
            page: 1,
        };
        setQuery(queryNew, "push");
        setKeywordSearch((_prev) => "");
        setStatusSearch((_prev) => null);
        setDateSearch([queryNew?.start_date ? moment(queryNew?.start_date || "", 'Y-MM-DD').toDate() : null, queryNew?.end_date ? moment(queryNew?.end_date || "", 'Y-MM-DD').toDate() : null]);
    };

    const triggerRefresh = async (type: string = '') => {
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
        handleCloseImportGenerateBoostingNewsV2();
    }
    //End::Update


    const [currentLang, setCurrentLang] = useState<string>('ko');
    const handleChangeLang = (_lang: string) => {
        const lang = newsDetail?.translates?.find((tr) => tr?.language_code === _lang);
        setNewsDetail((_prev) => (
            {
                ..._prev,
                title: lang?.title,
                body: lang?.body,
            } as INews
        ));
        setCurrentLang((_prev) => _lang);
    };


    useEffect(() => {
        if (!!queryModal?.news_ids) {
            handleQueryData();
        }
    }, [JSON.stringify(queryModal)]);

    const handleShowModalNews = (__news_ids: number[], __default_news_id: number | null = null) => {
        setQueryModal((_prev: any) => ({
            ..._prev,
            news_ids: (__news_ids || [])?.join(','),
            is_used: query?.is_used ?? '',
            type_page_no_param: '',
            page: 1
        }));
        if (!!__default_news_id) {
            setNewsDetail((_prev) => ({ ..._prev, id: __default_news_id } as INews));
        }
        setIsOpenModalNews((_prev) => true);
    };

    const handleCloseModalNews = () => {
        setIsOpenModalNews((_prev) => false);
        setQueryModal((_prev: any) => ({
            ..._prev,
            page: 1,
            news_ids: '',
        }))
    };

    const handleSetNewsDetail = (detail: INews | null) => {
        setNewsDetail((_prev) => detail);
        if (!!detail && (window?.innerWidth <= 900) && (!document_w.fullscreenElement && !document_w.mozFullScreenElement && !document_w.webkitFullscreenElement)) {
            setTimeout(async () => {
                try {
                    if (modalRef.current && modalRef.current.requestFullscreen) {
                        await modalRef?.current?.requestFullscreen();
                    } else if (modalRef.current && modalRef.current.webkitRequestFullscreen) {
                        await modalRef?.current?.webkitRequestFullscreen(); // Safari
                    } else if (modalRef.current && modalRef.current.msRequestFullscreen) {
                        await modalRef?.current?.msRequestFullscreen(); // IE
                    }
                } catch (error) {
                    //console.error("Failed to enter fullscreen:", error);
                }
            }, 280);
        }
    };

    const onCloseClick = () => {
        handleCloseModalNews();
        setCurrentLang((_prev) => 'ko');
        handleSetNewsDetail(null);
        setTypeShowInfoRight((_prev) => 'SOURCE');
        setListNews((prev: any) => ({
            list: [],
            total: 0,
        }));
    }

    const [typeShowInfoRight, setTypeShowInfoRight] = useState<'IMAGE' | 'SOURCE'>('SOURCE');

    const onShowInfoRightClick = () => {
        setTypeShowInfoRight((_prev) => (_prev === 'IMAGE' ? 'SOURCE' : 'IMAGE'));
    }

    const refContentNews = useRef<any>(null);

    const handleQueryData = async () => {
        setIsListNewsLoading((prev) => true);
        const res: any = await getAINewsByNormal(queryModal);
        setListNews((prev: any) => ({
            list: res?.data?.list || [],
            total: res?.data?.pagination?.total || 0,
        }));
        setIsListNewsLoading((prev) => false);
        if (queryModal?.page === 1) {
            setNewsDetail((_prev) => (res?.data?.list?.find((_n: any) => String(_n?.id) === String(newsDetail?.id)) || res?.data?.list[0]));
        }

        if (!!newsDetail && queryModal?.type_page_no_param) {
            if (queryModal?.type_page_no_param === 'prev') {
                setNewsDetail((_prev) => res?.data?.list[res?.data?.list?.length - 1]);
                return;
            }
            if (queryModal?.type_page_no_param === 'next') {
                setNewsDetail((_prev) => res?.data?.list[0]);
                return;
            }
        }
    };

    const handleLoadMore = () => {
        setQueryModal((_prev: any) => ({
            ..._prev,
            page: queryModal?.page + 1,
            type_page_no_param: 'next'
        }));
    }

    const handleLoadPrev = () => {
        setQueryModal((_prev: any) => ({
            ..._prev,
            page: queryModal?.page - 1,
            type_page_no_param: 'prev'
        }));
    }

    const scrollModalBodyToTop = () => {
        if (modalBodyInnerRef.current) {
            modalBodyInnerRef.current.scrollTo({ top: 0 });
        }
        if (modalSourceInnerRefs.current) {
            modalSourceInnerRefs.current.forEach((ref: any) => {
                if (ref) {
                    ref.scrollTo({ top: 0 });
                }
            });
        }
    };

    const handlePreviousNews = (index_news_current: number = 0) => {
        if (listNews?.list?.length) {
            const indexNewsPrevious = Number(index_news_current) - 1;
            const newsPrevious = listNews?.list[indexNewsPrevious];
            if (!!newsPrevious) {
                handleSetNewsDetail({
                    ...(newsPrevious),
                    index: indexNewsPrevious,
                    disabled_prev: false,
                    disabled_next: false
                });
                scrollModalBodyToTop();
                setCurrentLang((_prev) => 'ko');
            }
            if (!newsPrevious) {
                if (Number(queryModal?.page) > 1) {
                    handleLoadPrev();
                } else {
                    toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
                }
            }
        }
    };

    const handleNextNews = (index_news_current: number = 0) => {
        if (listNews?.list?.length) {
            const indexNewsNext = Number(index_news_current) + 1;
            const newsNext = listNews?.list[indexNewsNext];
            if (!!newsNext) {
                handleSetNewsDetail({
                    ...(newsNext),
                    index: indexNewsNext,
                    disabled_prev: false,
                    disabled_next: false,
                });
                scrollModalBodyToTop();
                setCurrentLang((_prev) => 'ko');
            }
            if (!newsNext) {
                if (Number(queryModal?.page) < Math.ceil(Number(listNews?.total) / Number(queryModal?.limit || 300))) {
                    handleLoadMore();
                } else {
                    toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
                }
            }
        }
    };

    const handleCloseImportGenerateBoostingNewsV2 = () => {
        setIsOpenImportGenerateBoostingNewsV2((_prev) => false);
    };

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                thWidth: 100,
                thClass: "align-middle text-center",
                Cell: (cell: any) => (
                    <>
                        <div className="text-center" style={{ minWidth: '80px' }}>
                            <CopyWrapper contentCopy={cell?.value}>
                                {cell?.value}
                            </CopyWrapper>
                        </div>

                    </>
                ),
            },
            {
                Header: t('Status'),
                accessor: "status",
                filterable: true,
                sortable: false,
                thWidth: 130,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const label = STATUS_LOG_OPTIONS_LANG?.find((s) => String(s?.value) === String(cell?.value))?.label || '';
                    const labelColor = STATUS_LOG_OPTIONS_COLOR[`${cell?.value || '1'}` as keyof typeof STATUS_LOG_OPTIONS_COLOR] || 'primary';
                    return (<div style={{ minWidth: '100px' }} className="d-flex flex-column align-items-start gap-2">
                        <span className={`rounded-pill badge bg-${labelColor}-subtle text-${labelColor} fs-12`}>
                            {label}
                        </span>
                    </div>)
                },
            },
            {
                Header: t('City Name'),
                accessor: "city_names",
                filterable: true,
                sortable: false,
                thWidth: 200,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="d-flex flex-column align-items-start" style={{ minWidth: '180px' }}>
                            {(item?.city_names || [])?.map((_city: any) => (
                                <div key={_city}>{_city}</div>
                            ))}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Keyword'),
                accessor: "keyword",
                filterable: true,
                sortable: true,
                thWidth: 150,
                thClass: 'align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div className="d-flex justify-content-between align-items-center cursor-pointer ">
                            <Link className='text-normal nav-link  flex-grow-1 hover-underline' to={`https://search.naver.com/search.naver?ssc=tab.news.all&where=news&sm=tab_jum&query=${cell?.value || ''}`} target="_blank" style={{ minWidth: '100px' }}>
                                {cell?.value || '-'}
                            </Link>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Article Title'),
                accessor: "title",
                filterable: true,
                sortable: false,
                thWidth: (window.innerWidth < 1650 ? 430 : 770),
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const news_id = item?.news_id;
                    return (<>
                        <div style={{ minWidth: '250px', maxWidth: '730px' }} className="fs-15  d-flex flex-column gap-1 align-items-start" onClick={() => {
                            if (!!news_id) {
                                handleShowModalNews([news_id], news_id);
                            }
                        }}>
                            <div className="cursor-pointer hover-underline">
                                <TooltipCustom
                                    title={t("Article upload at")}
                                    className="d-inline-block vertical-align-middle"
                                >
                                    <span className="text-muted">{(item?.upload_date || '')?.split(' ')?.[0] || ''}</span>
                                </TooltipCustom>
                                <span className="text-muted mx-1">|</span>
                                <HighlightText text={item?.title || '-'} keyword={item?.keyword || ''} opacity_bg={0.7} />
                            </div>
                        </div>
                    </>)
                },
            },
            {
                Header: t('Media'),
                accessor: "media_name",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _media_name = item?.media_name;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_media_name || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Section'),
                accessor: "partner_section_title",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _section = item?.partner_section_title;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_section || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Reporter ID'),
                accessor: "reporter_id",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _reporter_id = item?.reporter_id;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_reporter_id || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Reporter Byline'),
                accessor: "reporter_byline",
                filterable: true,
                sortable: false,
                thWidth: 140,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _reporter_byline = item?.reporter_byline;
                    return (<>
                        <div className="text-end" style={{ minWidth: '120px' }}>{_reporter_byline || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Category'),
                accessor: "category",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<div style={{ minWidth: '100px' }} className="d-flex flex-column align-items-start gap-2">
                        {(item?.categories || [])?.map((_c: any) => (
                            <span className="rounded-pill badge bg-primary-subtle text-primary fs-13" key={_c?.id}>{_c?.name}</span>
                        ))}
                    </div>)
                },
            },
            {
                Header: t('Tag'),
                accessor: "tag",
                filterable: true,
                sortable: false,
                thWidth: 120,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _tag = item?.tag;
                    return (<>
                        <div className="text-end" style={{ minWidth: '100px' }}>{_tag || '-'}</div>
                    </>)
                },
            },
            {
                Header: t('Error'),
                accessor: "error",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'align-middle text-start',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        {!!item?.error ? <div className="text-start text-danger" style={{ minWidth: '150px' }}>{`${item?.error || '-'}`}</div> : <div className="text-start text-muted">-</div>}
                    </>)
                },
            },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            {
                Header: t('Updated at'),
                accessor: "updated_at",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: 'text-end align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end" style={{ minWidth: '100px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
        ],
        [i18n?.language, idLoading, JSON.stringify(query), JSON.stringify(userPermissions)]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleChangePicker = (values: any[] = []) => {
        setDateSearch((_prev: any) => values);
    }

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);



    const refRight = useRef<any>(null);
    const refStart = useRef<any>(null);
    const [position, setPosition] = useState<any>({ left0: 0, top0: 20, left1: 20, left2: 30, top1: 20, top2: 20 });


    useEffect(() => {
        const getPosition = () => {
            if (refStart.current && modalBodyInnerRef.current && refRight.current) {
                const startRect = refStart.current.getBoundingClientRect();
                const leftRect = modalBodyInnerRef.current.getBoundingClientRect();
                const rightRect = refRight.current.getBoundingClientRect();

                setPosition((_prev: any) => ({ left0: startRect.left, left1: leftRect.left, left2: rightRect.left, top0: startRect.top, top1: leftRect.top, top2: rightRect.top }));
            }
        };

        // Timeout to ensure UI has rendered
        const timeoutId = setTimeout(() => {
            // Get position on mount
            getPosition();
        }, 0);

        // Optionally, track changes on window resize
        window.addEventListener("resize", getPosition);

        return () => {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", getPosition);
        };
    }, [JSON.stringify(newsDetail)]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.NEWS_WEATHER, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-5">
                                        <div>
                                            <h5 className="card-title mb-0 d-flex flex-wrap gap-1 gap-xxl-2">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isNewsWeatherWarningLogLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={newsWeatherWarningLogs?.pagination?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                                <span className="text-muted">|</span>
                                                <span className="d-flex">
                                                    <div className="me-2">{t('Initial')}:</div>
                                                    {(isNewsWeatherWarningLogLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={newsWeatherWarningLogs?.pagination?.init_count || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                                <span className="text-muted">|</span>
                                                <span className="d-flex">
                                                    <div className="me-2">{t('Failed')}:</div>
                                                    {(isNewsWeatherWarningLogLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={newsWeatherWarningLogs?.pagination?.error_count || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                                <span className="text-muted">|</span>
                                                <span className="d-flex">
                                                    <div className="me-2">{t('Completed')}:</div>
                                                    {(isNewsWeatherWarningLogLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={newsWeatherWarningLogs?.pagination?.success_count || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-7 col-sm-7 text-end">
                                        {/* {isHavePermissionRole(ROLES_FOR_APP.NEWS_RECOMPOSITION, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                                            onClick={() => setIsOpenImportGenerateBoostingNewsV2((_prev) => true)}
                                        >
                                            <i className="ri-upload-line align-bottom"></i>
                                            <span className="ms-1">{t('Button Import Bulk Generate Boosting News V2')}</span>
                                        </button>)}
                                        {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_V2, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-primary add-btn rounded-pill ms-2"
                                            onClick={() => setIsOpenModalConfigPrompt((_prev: any) => true)}
                                        >
                                            <i className="ri-settings-line align-bottom"></i>
                                            <span className="ms-1">{t('Config Prompt')}</span>
                                        </button>)} */}
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">
                                    <Col sm={6} md={6} lg={3} xl={2} xxl={2} className='mt-3  mt-3 mt-lg-2'>
                                        <LabelWrapper label={t('Status')} isShow={!!statusSearch}>
                                            <DropdownStatus
                                                name="status"
                                                dataList={STATUS_LOG_OPTIONS_LANG || []}
                                                placeholder={`${t('Status')}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={statusSearch || null}
                                                onChangeSelect={(e: any) => setStatusSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                                colors={['secondary', 'primary', 'danger', 'success']}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={3} xl={2} xxl={2} className='mt-3  mt-3 mt-lg-2'>
                                        <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Keyword')}...`}
                                                value={keywordSearch}
                                                onChange={(e) => setKeywordSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={3} xl={3} xxl={3} className='date-picker-wrapper-custom  mt-3 mt-lg-2'>
                                        <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                            <DatePickerCustom
                                                placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                startDate={startDate || null}
                                                endDate={endDate || null}
                                                onChangePicker={handleChangePicker}
                                                showOptions={[
                                                    'today', 'yesterday', 'two_day_ago',
                                                    'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                    'this_week', 'last_week',
                                                    'this_month', 'last_month',
                                                ]}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={3} xl={5} xxl={5} className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-lg-start mt-3 mt-lg-2">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isNewsWeatherWarningLogLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card"
                                    tableClass="align-middle sticky-table-log-news-travel"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={newsWeatherWarningLogs?.list?.length ? newsWeatherWarningLogs?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={newsWeatherWarningLogs?.pagination?.total}
                                    customPageCount={Math.ceil(Number(newsWeatherWarningLogs?.pagination?.total) / Number(newsWeatherWarningLogs?.pagination?.limit))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isNewsWeatherWarningLogLoading}
                                    isShowHeaderTableFixedTab={activeTab}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>
            <Modal
                isOpen={!!isOpenModalNews}
                centered={true}
                size="xl"
                className={`border-header-footer modal-fullscreen`}
                scrollable={false}
                toggle={handleCloseModalNews}
                keyboard={true}
                innerRef={modalRef}
            >
                <ModalHeader toggle={handleCloseModalNews}>
                    <div className="d-flex flex-column flex-sm-row gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            {t('Travel News')}: <span style={{ backgroundColor: '#ffff00' }}>{newsDetail?.keyword || ''}</span> {!!newsDetail?.keyword_sub && <> - <span style={{ backgroundColor: '#a8d2fb' }}>{newsDetail?.keyword_sub || ''}</span></>}
                            <ButtonLanguage currentLang={currentLang} handleChangeLang={handleChangeLang} />
                            <span key={newsDetail?.section} className={`rounded-pill me-2 badge bg-primary-subtle text-primary ms-2`}>
                                {newsDetail?.category?.name || ''}
                            </span>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <span className="position-absolute text-success fs-13 text-end px-2 d-none d-lg-block" style={{
                        top: position?.top0,
                        left: position?.left0 + 10,
                        transform: `translateY(-${position?.top0 - 10}px)`,
                        zIndex: 9,
                        backgroundColor: 'var(--vz-secondary-bg)'
                    }}>
                        {t('List News')}
                    </span>
                    <span className="position-absolute text-success fs-13 text-end px-2 d-none d-lg-block" style={{
                        top: position?.top1,
                        left: position?.left1 + 10,
                        transform: `translateY(-${position?.top1 - 10}px)`,
                        zIndex: 9,
                        backgroundColor: 'var(--vz-secondary-bg)'
                    }}>
                        {t('Generated News')}
                    </span>
                    <span className="position-absolute text-primary fs-13 text-end px-2 d-none d-lg-block" style={{
                        top: position?.top2,
                        left: position?.left2 + 10,
                        transform: `translateY(-${position?.top2 - 10}px)`,
                        zIndex: 9,
                        backgroundColor: 'var(--vz-secondary-bg)'
                    }}>
                        {t('Prompt')}
                    </span>
                    <div className="h-100-pc w-100 overflow-x-hidden">
                        <Row className="w-100-pc px-0 h-100-pc">
                            <Col lg={3} className="h-100-pc  mt-4 mt-md-0 mb-3 mb-lg-0" >
                                <span className="position-absolute text-success fs-13 text-end px-2 d-block d-lg-none" style={{
                                    top: 0,
                                    left: 5,
                                    transform: `translateY(-${10}px)`,
                                    zIndex: 9,
                                    backgroundColor: 'var(--vz-secondary-bg)'
                                }}>
                                    {t('News List')}
                                </span>
                                <Row className={`h-100-pc align-content-between position-relative gap-3 gap-lg-0 `}>
                                    <div className={`box-source-image color-scrollbar-os overflow-x-hidden overflow-y-auto ms-0 ms-lg-3`} ref={refStart} style={{ border: '1.5px dashed var(--vz-success)', width: 'fit-content', minHeight: '80dvh' }}>
                                        <div className="d-flex flex-column gap-3 mt-3 px-1 pb-5">
                                            {(listNews?.list || [])?.map((_n, _idx) => (
                                                <Card className={`position-relative border cursor-pointer  border-hover-success mb-0 ${String(_n?.id) === String(newsDetail?.id) ? 'border-success border-2' : ''}`} key={_n?.id} onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ..._n, index: _idx }) }}>
                                                    <CardBody style={{ position: 'relative' }}>
                                                        <div className="d-sm-flex" >
                                                            <div className="flex-grow-1">
                                                                <div className="d-flex mb-3 justify-content-between align-items-center">
                                                                    <div>
                                                                        {String(newsDetail?.news_type) === String(KEYWORD_TYPE.CONTENT) ? <></> : <><span className="text-muted fs-13">{t('Total Reviews')}:</span> {formatNumberWithCommas(Number(_n?.source_travel_place?.total_blog_reviews_count) + Number(_n?.source_travel_place?.total_visitor_reviews_count))}</>}
                                                                    </div>
                                                                    <div>
                                                                        <span className={`rounded-pill badge bg-${COLORS_STATUS_NEWS[`${_n?.is_used || 0}`] || 'success'}`}>
                                                                            {STATUS_NEWS_OPTIONS_LANG?.find((s) => String(s?.value) === String(_n?.is_used))?.label || ''}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <h5 className="">
                                                                    <span className="align-text-top  me-1">{!!_n?.is_completed ? <i className='ri-checkbox-line text-success fs-20' /> : <i className='ri-checkbox-indeterminate-line text-danger fs-20' />}</span>
                                                                    <HighlightText text={_n?.title || ''} keyword={_n?.keyword || ''} opacity_bg={0.7} />
                                                                </h5>
                                                                <ul className="list-inline mb-0 d-flex justify-content-between">
                                                                    <li className="list-inline-item">
                                                                    </li>
                                                                    <li className="list-inline-item">
                                                                        {String(newsDetail?.news_type) === String(KEYWORD_TYPE.CONTENT) ? <><span className="text-muted fs-13">{t('Created at2')}:</span> {_n?.created_at || ''}</> : <><span className="text-muted fs-13">{t('Source Publish Date')}:</span> {_n?.source_publish_time || ''}</>}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                    <span className={`position-absolute text-${String(_n?.id) === String(newsDetail?.id) ? 'success' : 'muted'} fs-13 text-end px-2`} style={{
                                                        top: '-10px',
                                                        left: 5,
                                                        zIndex: 0,
                                                        backgroundColor: 'var(--vz-secondary-bg)'
                                                    }}>
                                                        #{_n?.id}
                                                    </span>
                                                </Card>
                                            ))}
                                        </div>
                                        <div className="text-center my-2 position-absolute" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                            {!!isListNewsLoading && <Spinner size="sm" className="text-success fs-20 align-middle" style={{ width: '30px', height: '30px' }}></Spinner>}
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col lg={6} className="h-100-pc mt-2 mt-md-0">
                                <span className="position-absolute text-success fs-13 text-end px-2 d-block d-lg-none" style={{
                                    top: 0,
                                    left: 5,
                                    transform: `translateY(-${10}px)`,
                                    zIndex: 9,
                                    backgroundColor: 'var(--vz-secondary-bg)'
                                }}>
                                    {t('Generated News')}
                                </span>
                                <div ref={modalBodyInnerRef} className="inner-modal-body color-scrollbar-os position-relative p-0 editor-border-radius-0" style={{ border: '1.5px dashed var(--vz-success)' }}>
                                    <BoxGeneratedNews ref={refContentNews} newsDetail={newsDetail} isSubKeywordFrequency={false} isShowStatusAndMedia={true} isHighlightDate={true} isShowHighlightText={true} />
                                </div>
                            </Col>
                            <Col lg={3} className="h-100-pc ms-0 ms-lg-0 pe-3 me-lg-0 mt-4  mt-md-0" >
                                <span className="position-absolute text-primary fs-13 text-end px-2 d-block d-lg-none" style={{
                                    top: 0,
                                    left: 5,
                                    transform: `translateY(-${10}px)`,
                                    zIndex: 9,
                                    backgroundColor: 'var(--vz-secondary-bg)'
                                }}>
                                    {t('Prompt')}
                                </span>
                                {<div className={`row h-100-pc overflow-y-auto color-scrollbar-os align-content-start gap-3 gap-lg-0`} ref={refRight}>
                                    <div ref={(el) => (modalSourceInnerRefs.current[0] = el)} style={{ height: '100%', whiteSpace: 'pre-line' }}
                                        className={`color-scrollbar-os position-relative box-source-news chill-1 py-3`}

                                    >
                                        <HighlightText text={newsDetail?.source_weather?.prompt || ''} keyword={newsDetail?.keyword || ''} is_highlight_date={true} />
                                    </div>
                                </div>
                                }
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter className="position-relative footer-button-new" lang={i18n?.language || 'en'}>
                    <BoxFooterNews
                        newsDetail={newsDetail}
                        isListNewsLoading={isListNewsLoading}
                        type_page_no_param={query?.type_page_no_param}
                        currentLang={currentLang}
                        isShowButtonGenerateNews={String(newsDetail?.news_type) !== String(KEYWORD_TYPE.CONTENT)}
                        isShowSave={true}
                        isShowCategoryOnPublish={true}
                        handlePreviousNews={handlePreviousNews}
                        handleNextNews={handleNextNews}
                        onCloseClick={onCloseClick}
                        onShowInfoRightClick={onShowInfoRightClick}
                        typeShowInfoRight={typeShowInfoRight}
                        isShowButtons={false}
                    />
                </ModalFooter>
            </Modal>

            <ModalImportGenerateBoostingNewsV2
                isOpen={isOpenImportGenerateBoostingNewsV2}
                onRefresh={triggerRefresh}
                onClose={handleCloseImportGenerateBoostingNewsV2}
            />

            <ModalPrompt
                isOpen={isOpenModalConfigPrompt}
                onClose={() => setIsOpenModalConfigPrompt((_prev: any) => false)}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default LogList;